import comp, { CreatePostBase } from "./CreatePost";
export default comp;

export { CreatePostBase };
